/**
 * A function to create a log object for the 'devCenterNewBusinessFormOpened' event (evid: 10)
 *
 * Event description: Developer opened a new business (company) form page.
 *
 * @param {devCenterNewBusinessFormOpenedParams} params - The parameters for this event
 * @return {LogObject<devCenterNewBusinessFormOpenedParams>} LogObject<devCenterNewBusinessFormOpenedParams>
 */
export function devCenterNewBusinessFormOpened(params) {
    return { evid: 10, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterHomepageOpenDevCenter' event (evid: 100)
 *
 * Event description: The user opened dev.wix homepage
 *
 * @param {devCenterHomepageOpenDevCenterParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {Url} referer - Identifies the address of the previous web page
 * @property {GUID} msid - msid
 * @return {LogObject<devCenterHomepageOpenDevCenterParams>} LogObject<devCenterHomepageOpenDevCenterParams>
 */
export function devCenterHomepageOpenDevCenter(params) {
    return { evid: 100, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterOathClickOnPermissionCatalog' event (evid: 101)
 *
 * Event description: Click On Permission catalog
 *
 * @param {devCenterOathClickOnPermissionCatalogParams} params - The parameters for this event
 * @property {string} app_id - app id
 * @return {LogObject<devCenterOathClickOnPermissionCatalogParams>} LogObject<devCenterOathClickOnPermissionCatalogParams>
 */
export function devCenterOathClickOnPermissionCatalog(params) {
    return { evid: 101, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterOathClickOnSearch' event (evid: 102)
 *
 * Event description: Click On filter by category
 *
 * @param {devCenterOathClickOnSearchParams} params - The parameters for this event
 * @property {string} search_term - search term
 * @property {string} app_id - app id
 * @property {string} hosting_platform - hosting platform (dev center, blocks etc.)
 * @property {string} platform - platform
 * @return {LogObject<devCenterOathClickOnSearchParams>} LogObject<devCenterOathClickOnSearchParams>
 */
export function devCenterOathClickOnSearch(params) {
    return { evid: 102, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterReviewsDropdownChoice' event (evid: 109)
 *
 * Event description: sort by dropdown
 *
 * @param {devCenterReviewsDropdownChoiceParams} params - The parameters for this event
 * @property {string} name - name of the drop down selected
 * @property {string} sort_by - sort by
 * @property {GUID} app_id - app id
 * @return {LogObject<devCenterReviewsDropdownChoiceParams>} LogObject<devCenterReviewsDropdownChoiceParams>
 */
export function devCenterReviewsDropdownChoice(params) {
    return { evid: 109, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterCreateNewAppClick' event (evid: 11)
 *
 * Event description: Triggered by clicking on 'create new app' button in 'my apps' page. The click opens a popover.
 *
 * @param {devCenterCreateNewAppClickParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} app_id - app_id
 * @return {LogObject<devCenterCreateNewAppClickParams>} LogObject<devCenterCreateNewAppClickParams>
 */
export function devCenterCreateNewAppClick(params) {
    return { evid: 11, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterStatsDisplayData' event (evid: 110)
 *
 * Event description: Dev Center -  Stats - Display Settings.
 *
 * @param {devCenterStatsDisplayDataParams} params - The parameters for this event
 * @property {number} time_interval - 1 = day , 7 = week, 30 = month
 * @property {string} tab - overview/details
 * @property {GUID} app_id - app id
 * @property {string} period - period of time
 * @return {LogObject<devCenterStatsDisplayDataParams>} LogObject<devCenterStatsDisplayDataParams>
 */
export function devCenterStatsDisplayData(params) {
    return { evid: 110, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterWebhookPublicKeyLearnMore' event (evid: 114)
 *
 * Event description: Public Key Learn More Click
 *
 * @param {devCenterWebhookPublicKeyLearnMoreParams} params - The parameters for this event
 * @property {GUID} app_id - app id
 * @return {LogObject<devCenterWebhookPublicKeyLearnMoreParams>} LogObject<devCenterWebhookPublicKeyLearnMoreParams>
 */
export function devCenterWebhookPublicKeyLearnMore(params) {
    return { evid: 114, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterTranslationClickOnTranslateAnItem' event (evid: 11404)
 *
 * Event description: Sent when user is clicking on Translate an Item in a language table
 *
 * @param {devCenterTranslationClickOnTranslateAnItemParams} params - The parameters for this event
 * @property {string} translation_status - the translated status as it appears in the table, f.e: translated/not translated/partially translated/missing required fields
 * @property {string} item_name - f.e: market listing & pricing/ my orders/ welcome reminder/ etc.
 * @property {string} language - the language the user added
 * @property {string} app_id - app id
 * @property {string} component_id - if the item is a component(=extension) please report the component id, otherwise null
 * @property {string} item_type - the item type as it appears in the table:, f.e: app market/ page/ automation/ notification/ widget/ etc.
 * @return {LogObject<devCenterTranslationClickOnTranslateAnItemParams>} LogObject<devCenterTranslationClickOnTranslateAnItemParams>
 */
export function devCenterTranslationClickOnTranslateAnItem(params) {
    return { evid: 11404, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterTranslationClickOnActivateInactivateTranslationForAnItem' event (evid: 11405)
 *
 * Event description: Sent when user is clicking on Activate/Inactivate translation for an item in the language table
 *
 * @param {devCenterTranslationClickOnActivateInactivateTranslationForAnItemParams} params - The parameters for this event
 * @property {string} translation_status - the translated status as it appears in the table, f.e: translated/not translated/partially translated/missing required fields
 * @property {string} item_name - f.e: market listing & pricing/ my orders/ welcome reminder/ etc.
 * @property {string} language - the language the user added
 * @property {string} app_id - app id
 * @property {string} component_id - if the item is a component(=extension) please report the component id, otherwise null
 * @property {string} item_type - the item type as it appears in the table:, f.e: app market/ page/ automation/ notification/ widget/ etc.
 * @property {string} action - activate/inactivate
 * @return {LogObject<devCenterTranslationClickOnActivateInactivateTranslationForAnItemParams>} LogObject<devCenterTranslationClickOnActivateInactivateTranslationForAnItemParams>
 */
export function devCenterTranslationClickOnActivateInactivateTranslationForAnItem(params) {
    return { evid: 11405, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterTranslationTranslationWasSaved' event (evid: 11406)
 *
 * Event description: Sent when Translation of an Item/component was saved (when user clicked on save translation and it was successfully saved)
 *
 * @param {devCenterTranslationTranslationWasSavedParams} params - The parameters for this event
 * @property {string} item_name - f.e: market listing & pricing/ my orders/ welcome reminder/ etc.
 * @property {string} language - the language the user added
 * @property {string} app_id - app id
 * @property {string} component_id - if the item is a component(=extension) please report the component id, otherwise null
 * @property {string} item_type - the item type as it appears in the table:, f.e: app market/ page/ automation/ notification/ widget/ etc.
 * @property {string} translated_fields - JSON when the key is the Form section and the values are a list of the fields the user filled in this form’s section. If there’s is no section like when the item is component send “General” as section F.e:{“Media”:[“images”,”label”,”youtube video url”],”Pricing Plans”:[“name”,”first benefit”]}
 * @return {LogObject<devCenterTranslationTranslationWasSavedParams>} LogObject<devCenterTranslationTranslationWasSavedParams>
 */
export function devCenterTranslationTranslationWasSaved(params) {
    return { evid: 11406, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterManageExtensionsClickOnAnActionInMoreActionsMenu3DotsMenu' event (evid: 11408)
 *
 * Event description: Build Your App - Manage Extensions - when a user is clicking on action in more actions menu of specific component.
 *
 * @param {devCenterManageExtensionsClickOnAnActionInMoreActionsMenu3DotsMenuParams} params - The parameters for this event
 * @property {string} component_name - dashboard, website, integration
 * @property {string} action_name - edit extension/ delete/etc.
 * @property {string} built_on - where the component was built on: devcenter/blocks/cli for apps
 * @property {GUID} app_id - app id
 * @property {string} component_id - component ID
 * @property {string} component_type - the type of the specific component for example - website: page, worker...
 * @return {LogObject<devCenterManageExtensionsClickOnAnActionInMoreActionsMenu3DotsMenuParams>} LogObject<devCenterManageExtensionsClickOnAnActionInMoreActionsMenu3DotsMenuParams>
 */
export function devCenterManageExtensionsClickOnAnActionInMoreActionsMenu3DotsMenu(params) {
    return { evid: 11408, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterManageExtensionsClickOnDeleteInDeleteExtensionModalApproveExtensionDeletion' event (evid: 11409)
 *
 * Event description: Build Your App - Manage Extensions - when a user is clicking on 'delete' to delete extension in the extension's deletion modal (approve the deletion).
 *
 * @param {devCenterManageExtensionsClickOnDeleteInDeleteExtensionModalApproveExtensionDeletionParams} params - The parameters for this event
 * @property {string} component_name - dashboard, website, integration
 * @property {string} built_on - where the component was built on: devcenter/blocks/cli for apps
 * @property {GUID} app_id - app id
 * @property {string} component_id - component ID
 * @property {string} component_type - the type of the specific component for example - website: page, worker...
 * @return {LogObject<devCenterManageExtensionsClickOnDeleteInDeleteExtensionModalApproveExtensionDeletionParams>} LogObject<devCenterManageExtensionsClickOnDeleteInDeleteExtensionModalApproveExtensionDeletionParams>
 */
export function devCenterManageExtensionsClickOnDeleteInDeleteExtensionModalApproveExtensionDeletion(params) {
    return { evid: 11409, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterBuildYourAppClickOnCreateExtension' event (evid: 11412)
 *
 * Event description: In the Build Your App  - Extensions (Components) page - click on create extension to open Extensions Modal.
 * There are 2 possible origins: 'Create Extension' top button, 'Create Extension' empty state button.
 *
 * @param {devCenterBuildYourAppClickOnCreateExtensionParams} params - The parameters for this event
 * @property {boolean} is_wix_app - true = internal app, false = TPA's app
 * @property {string} origin - top button/ empty state button
 * @property {string} app_status - current status : DECLINED / PUBLISHED / IN_REVIEW / SUBMITTED / APPROVED / DRAFT
 * @property {GUID} app_id - app id
 * @return {LogObject<devCenterBuildYourAppClickOnCreateExtensionParams>} LogObject<devCenterBuildYourAppClickOnCreateExtensionParams>
 */
export function devCenterBuildYourAppClickOnCreateExtension(params) {
    return { evid: 11412, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterJsonEditorClickOnTabInTheDocumentationSidepanel' event (evid: 11413)
 *
 * Event description: In the JSON Editor  - click on a tab ('properties' tab or 'example' tab) in the documentation side panel.
 *
 * @param {devCenterJsonEditorClickOnTabInTheDocumentationSidepanelParams} params - The parameters for this event
 * @property {string} tab_name - properties/example
 * @property {string} component_category - Dashboard / Website /Integration / TBD
 * @property {boolean} is_wix_app - true = internal app, false = TPA's app
 * @property {string} app_status - current status : DECLINED / PUBLISHED / IN_REVIEW / SUBMITTED / APPROVED / DRAFT
 * @property {GUID} app_id - app id
 * @property {string} component_id - (only for Edit) a unique identifier
 * @property {string} component_type - page / widget / dashboard etc.
 * @return {LogObject<devCenterJsonEditorClickOnTabInTheDocumentationSidepanelParams>} LogObject<devCenterJsonEditorClickOnTabInTheDocumentationSidepanelParams>
 */
export function devCenterJsonEditorClickOnTabInTheDocumentationSidepanel(params) {
    return { evid: 11413, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterJsonEditorClickOnCopyExampleInTheDocumentationSidepanel' event (evid: 11414)
 *
 * Event description: In the JSON Editor  - click on copy example in the documentation side panel.
 *
 * @param {devCenterJsonEditorClickOnCopyExampleInTheDocumentationSidepanelParams} params - The parameters for this event
 * @property {boolean} is_wix_app - true = internal app, false = TPA's app
 * @property {string} app_status - current status : DECLINED / PUBLISHED / IN_REVIEW / SUBMITTED / APPROVED / DRAFT
 * @property {GUID} app_id - app id
 * @property {string} component_id - (only for Edit) a unique identifier
 * @property {string} component_type - page / widget / dashboard etc.
 * @return {LogObject<devCenterJsonEditorClickOnCopyExampleInTheDocumentationSidepanelParams>} LogObject<devCenterJsonEditorClickOnCopyExampleInTheDocumentationSidepanelParams>
 */
export function devCenterJsonEditorClickOnCopyExampleInTheDocumentationSidepanel(params) {
    return { evid: 11414, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterMyAppsMoveAppToArchive' event (evid: 11415)
 *
 * Event description: User is approving the move of an app to archive in the move to archive modal
 *
 * @param {devCenterMyAppsMoveAppToArchiveParams} params - The parameters for this event
 * @property {string} last_update - the app last update date as it appears in My Apps page
 * @property {string} app_status - the app_status: DRAFT/SUBMITTED/PUBLISHED/DECLINED
 * @property {GUID} app_id - app id
 * @property {string} latest_version_status - the lastest app version status as it appears in My Apps page
 * @property {string} dev_ux_type - UX flavor: developer ,no-code
 *
 * @return {LogObject<devCenterMyAppsMoveAppToArchiveParams>} LogObject<devCenterMyAppsMoveAppToArchiveParams>
 */
export function devCenterMyAppsMoveAppToArchive(params) {
    return { evid: 11415, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'copyOfDevCenterWebhookPublicKeyOpen' event (evid: 115)
 *
 * Event description: Dev Center - Webhook - Public Key Open.
 *
 * @param {copyOfDevCenterWebhookPublicKeyOpenParams} params - The parameters for this event
 * @property {boolean} is_wix_app - is_wix_app
 * @property {string} app_status - app_status
 * @property {number} num_webhooks - how many webhooks currently exist in the subscriptions table?  (new from 04/23)
 * @property {GUID} app_id - app id
 * @return {LogObject<copyOfDevCenterWebhookPublicKeyOpenParams>} LogObject<copyOfDevCenterWebhookPublicKeyOpenParams>
 */
export function copyOfDevCenterWebhookPublicKeyOpen(params) {
    return { evid: 115, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterDashboardBuildYourAppWebhooksApiCategoryTypes' event (evid: 116)
 *
 * Event description: In the  Build Your App  - Webhooks page after the user clicks on Add Webhook Button what API Category he chose and the type.
 *
 * @param {devCenterDashboardBuildYourAppWebhooksApiCategoryTypesParams} params - The parameters for this event
 * @property {string} api_category - Wix Stores, Marketing...
 * @property {boolean} is_wix_app - [DEPRECATE] is_wix_app
 * @property {string} app_status - [DEPRECATE] app_status
 * @property {GUID} app_id - app id
 * @property {string} type - name of the api that was selected (also known as event name)
 * @property {string} slug - slug
 * @return {LogObject<devCenterDashboardBuildYourAppWebhooksApiCategoryTypesParams>} LogObject<devCenterDashboardBuildYourAppWebhooksApiCategoryTypesParams>
 */
export function devCenterDashboardBuildYourAppWebhooksApiCategoryTypes(params) {
    return { evid: 116, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devWixComHeaderTabClick' event (evid: 12)
 *
 * Event description: Click on one of the tabs in the header, dev.wix.com website.
 *
 * @param {devWixComHeaderTabClickParams} params - The parameters for this event
 * @property {string} tabName - which tab was clicked (e.g 'my_apps','documentation','api reference','app market')
 * @property {string} pageName - e.g - 'wix developers' , 'documents', etc...
 * @return {LogObject<devWixComHeaderTabClickParams>} LogObject<devWixComHeaderTabClickParams>
 */
export function devWixComHeaderTabClick(params) {
    return { evid: 12, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterWebhooksLogsCopy' event (evid: 121)
 *
 * Event description: Webhooks- Logs - the user chose to copy instance id or to view payload
 *
 * @param {devCenterWebhooksLogsCopyParams} params - The parameters for this event
 * @property {string} event_name - Event's name
 * @property {boolean} is_wix_app - Is wix app?
 * @property {DateTime} time_sent - time sent
 * @property {string} response - response status
 * @property {string} app_status - App's status
 * @property {GUID} app_id - app id
 * @property {GUID} instance_id - instance_id
 * @property {string} action_type - The action the user did - Copy instance ID / View payload
 * @property {number} index - index - row number -from the top to the button (first row=0)
 * @return {LogObject<devCenterWebhooksLogsCopyParams>} LogObject<devCenterWebhooksLogsCopyParams>
 */
export function devCenterWebhooksLogsCopy(params) {
    return { evid: 121, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterWebhookPublicKeyClose' event (evid: 124)
 *
 * Event description: Webhook - Public Key Close
 *
 * @param {devCenterWebhookPublicKeyCloseParams} params - The parameters for this event
 * @property {boolean} is_wix_app - is_wix_app
 * @property {string} app_status - [DEPRECATE]  App status  (new from 04/23)
 * @property {GUID} app_id - app id
 * @property {string} action_type - what did the user chose to do with the public key? will get : Download / Copy key /  Done / Learn more  (new from 04/23)
 * @return {LogObject<devCenterWebhookPublicKeyCloseParams>} LogObject<devCenterWebhookPublicKeyCloseParams>
 */
export function devCenterWebhookPublicKeyClose(params) {
    return { evid: 124, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'developerCenterVersionSubmitted' event (evid: 13)
 *
 * Event description: Developer Center - Version Submitted
 *
 * @param {developerCenterVersionSubmittedParams} params - The parameters for this event
 * @property {string} versionNumber - string e.g '10.0.5'
 * @property {string} displayVersion - string e.g 'V1'
 * @property {GUID} appId - app_id
 * @return {LogObject<developerCenterVersionSubmittedParams>} LogObject<developerCenterVersionSubmittedParams>
 */
export function developerCenterVersionSubmitted(params) {
    return { evid: 13, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterStatsShowingDataCustomDates' event (evid: 135)
 *
 * Event description: Stats - Showing data Click Custom dates
 *
 * @param {devCenterStatsShowingDataCustomDatesParams} params - The parameters for this event
 * @property {string} tab - overview/settings
 * @property {string} end_date - end date
 * @property {GUID} app_id - app id
 * @property {string} startDate - start date
 * @return {LogObject<devCenterStatsShowingDataCustomDatesParams>} LogObject<devCenterStatsShowingDataCustomDatesParams>
 */
export function devCenterStatsShowingDataCustomDates(params) {
    return { evid: 135, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterVisitToWebhookLogger' event (evid: 139)
 *
 * Event description: User visits the webhook logger page
 *
 * @param {devCenterVisitToWebhookLoggerParams} params - The parameters for this event
 * @property {GUID} app_id - app id
 * @return {LogObject<devCenterVisitToWebhookLoggerParams>} LogObject<devCenterVisitToWebhookLoggerParams>
 */
export function devCenterVisitToWebhookLogger(params) {
    return { evid: 139, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'developerCenterSubmitFormOpened' event (evid: 14)
 *
 * Event description: Developer Center - Submit Form Opened
 *
 * @param {developerCenterSubmitFormOpenedParams} params - The parameters for this event
 * @property {string} versionNumber - string e.g '10.0.5'
 * @property {string} displayVersion - string e.g 'V1'
 * @property {GUID} appId - app_id
 * @return {LogObject<developerCenterSubmitFormOpenedParams>} LogObject<developerCenterSubmitFormOpenedParams>
 */
export function developerCenterSubmitFormOpened(params) {
    return { evid: 14, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterChooseFilterInWebhookLogger' event (evid: 140)
 *
 * Event description: User filter the webhook logger page
 *
 * @param {devCenterChooseFilterInWebhookLoggerParams} params - The parameters for this event
 * @property {string} filter_type - what filter did the user chose?
 * @property {GUID} app_id - app id
 * @return {LogObject<devCenterChooseFilterInWebhookLoggerParams>} LogObject<devCenterChooseFilterInWebhookLoggerParams>
 */
export function devCenterChooseFilterInWebhookLogger(params) {
    return { evid: 140, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterWebhookHoverNotification' event (evid: 141)
 *
 * Event description: hover over webhook notification
 *
 * @param {devCenterWebhookHoverNotificationParams} params - The parameters for this event
 * @property {GUID} app_id - app_id
 * @return {LogObject<devCenterWebhookHoverNotificationParams>} LogObject<devCenterWebhookHoverNotificationParams>
 */
export function devCenterWebhookHoverNotification(params) {
    return { evid: 141, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterWebhookSendMetadata' event (evid: 142)
 *
 * Event description: Dev Center - Webhook - Send Metadata
 *
 * @param {devCenterWebhookSendMetadataParams} params - The parameters for this event
 * @property {GUID} app_id - app_id
 * @property {string} webhook_deprecation_status - webhook_deprecation_status
 * @property {string} webhook_slug - webhook slug
 * @return {LogObject<devCenterWebhookSendMetadataParams>} LogObject<devCenterWebhookSendMetadataParams>
 */
export function devCenterWebhookSendMetadata(params) {
    return { evid: 142, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterWebhookOpenModalNewWebhook' event (evid: 143)
 *
 * Event description: Dev Center - Webhook - Open Modal
 *
 * @param {devCenterWebhookOpenModalNewWebhookParams} params - The parameters for this event
 * @property {string} webhook_slug - webhook slug
 * @property {GUID} app_id - app_id
 * @return {LogObject<devCenterWebhookOpenModalNewWebhookParams>} LogObject<devCenterWebhookOpenModalNewWebhookParams>
 */
export function devCenterWebhookOpenModalNewWebhook(params) {
    return { evid: 143, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterWebhookVersionAdded' event (evid: 144)
 *
 * Event description: Dev Center - Webhook - Click subscribe or cancel
 *
 * @param {devCenterWebhookVersionAddedParams} params - The parameters for this event
 * @property {string} callback_url - callback url  (new from 04/23)
 * @property {string} event_name - Event's name (new from 04/2023)
 * @property {boolean} is_wix_app - [DEPRECATE] is_wix_app
 * @property {string} permission_status - Has permission / Permission added: {chosen permission name} / Automatically added {added permission name}  (new from 04/23)
 * @property {string} origin - [DEPRECATE]
 * origin
 * @property {string} app_status - [DEPRECATE] app_status
 * @property {string} category - Event's category (new from 04/2023)
 * @property {GUID} app_id - app_id
 * @property {string} end_type - Subscribe / Cancel (new from 04/23)
 * @property {string} webhook_slug - webhook slug
 * @return {LogObject<devCenterWebhookVersionAddedParams>} LogObject<devCenterWebhookVersionAddedParams>
 */
export function devCenterWebhookVersionAdded(params) {
    return { evid: 144, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterDashboardClickOnLearnMoreInTestYourApp' event (evid: 146)
 *
 * Event description: The user clicks on 'Learn More' in the popover menu of 'Test Your App'.
 *
 * @param {devCenterDashboardClickOnLearnMoreInTestYourAppParams} params - The parameters for this event
 * @property {boolean} is_sites_limit - Did the developer reach the number of test sites limit
 * @property {string} location - location
 * @property {boolean} has_wix_site - has_wix_site
 * @property {GUID} app_id - app id
 * @property {number} number_of_dev_sites - How many sites does the developer already have
 * @return {LogObject<devCenterDashboardClickOnLearnMoreInTestYourAppParams>} LogObject<devCenterDashboardClickOnLearnMoreInTestYourAppParams>
 */
export function devCenterDashboardClickOnLearnMoreInTestYourApp(params) {
    return { evid: 146, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterDashboardClickOnLearnMoreInCreateSite' event (evid: 147)
 *
 * Event description: The user clicks on 'Learn More' in the modal window menu of 'Create Site'.
 *
 * @param {devCenterDashboardClickOnLearnMoreInCreateSiteParams} params - The parameters for this event
 * @property {boolean} is_sites_limit - is_sites_limit
 * @property {string} location - the location of the click (main dashboard, Components section...)
 * @property {boolean} has_wix_site - has_wix_site
 * @property {GUID} app_id - app id
 * @property {number} number_of_dev_sites - number_of_dev_sites
 * @return {LogObject<devCenterDashboardClickOnLearnMoreInCreateSiteParams>} LogObject<devCenterDashboardClickOnLearnMoreInCreateSiteParams>
 */
export function devCenterDashboardClickOnLearnMoreInCreateSite(params) {
    return { evid: 147, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterDashboardCreateSiteMenuClick148' event (evid: 148)
 *
 * Event description: The developer clicks on one of the options on the modal window menu of the Create Development Site menu - Takes effect only when the developer hasn't reached sites limit
 *
 * @param {devCenterDashboardCreateSiteMenuClick148Params} params - The parameters for this event
 * @property {string} location - location
 * @property {string} click_type - close/create site
 * @property {string} app_install_type - app_install_type
 * @property {boolean} has_wix_site - Does the user has any Wix site or not
 * @property {GUID} app_id - app id
 * @property {number} number_of_dev_sites - How many dev sites does the user have
 * @return {LogObject<devCenterDashboardCreateSiteMenuClick148Params>} LogObject<devCenterDashboardCreateSiteMenuClick148Params>
 */
export function devCenterDashboardCreateSiteMenuClick148(params) {
    return { evid: 148, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'dashboardClickOnTestYourApp' event (evid: 149)
 *
 * Event description: The User Clicks On test your app button from the dashboard or dashboard slide bar sections. (Doesn't overlap with event#52, only one event is triggered each time)
 *
 * @param {dashboardClickOnTestYourAppParams} params - The parameters for this event
 * @property {number} num_of_dev_sites - How many dev sites does the developer have
 * @property {string} location - location
 * @property {boolean} has_wix_site - Does the user has a Wix site or not
 * @property {GUID} app_id - app id
 * @return {LogObject<dashboardClickOnTestYourAppParams>} LogObject<dashboardClickOnTestYourAppParams>
 */
export function dashboardClickOnTestYourApp(params) {
    return { evid: 149, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'developerCenterNewBusinessCreated' event (evid: 15)
 *
 * Event description: Developer Center - New Business Created
 *
 * @param {developerCenterNewBusinessCreatedParams} params - The parameters for this event
 * @property {string} companySize - size of company
 * @property {string} industry - business type of company
 * @property {string} cameFrom - how did developer heard about us
 * @property {string} otherPlatforms - developer's experience with other services
 * @property {string} businessName - (deprecated) developer's name of business
 * @property {string} compIntent - developer's intent of business with wix
 * @property {GUID} compId - company (business) id
 * @property {boolean} termsAndConditions - (deprecated) terms and conditions
 * @return {LogObject<developerCenterNewBusinessCreatedParams>} LogObject<developerCenterNewBusinessCreatedParams>
 */
export function developerCenterNewBusinessCreated(params) {
    return { evid: 15, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterNavigationSideMenuClick' event (evid: 150)
 *
 * Event description: Triggered when user is clicking on navigation panel and the action is meaningful (page change, menu expand/collapse)
 *
 * @param {devCenterNavigationSideMenuClickParams} params - The parameters for this event
 * @property {string} click_type - page-change/expand-menu/collapse-menu
 * @property {GUID} uuid - uuid
 * @property {string} click_tag - navigation click title
 * @property {string} from_page - current page/tab
 * @property {string} app_id - app id
 * @return {LogObject<devCenterNavigationSideMenuClickParams>} LogObject<devCenterNavigationSideMenuClickParams>
 */
export function devCenterNavigationSideMenuClick(params) {
    return { evid: 150, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterAppSubmissionPopUpAction' event (evid: 152)
 *
 * Event description: Triggered when user is clicking on the blockers/recommendations actions
 *
 * @param {devCenterAppSubmissionPopUpActionParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} app_id - app id
 * @property {string} tag_type - oAuth, missing logo etc.
 * @property {string} action_type - fix, dismiss etc.
 * @return {LogObject<devCenterAppSubmissionPopUpActionParams>} LogObject<devCenterAppSubmissionPopUpActionParams>
 */
export function devCenterAppSubmissionPopUpAction(params) {
    return { evid: 152, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterPublishYourAppContactInfoUpdated' event (evid: 155)
 *
 * Event description: Contact info edited and saved
 *
 * @param {devCenterPublishYourAppContactInfoUpdatedParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} app_id - app_id
 * @return {LogObject<devCenterPublishYourAppContactInfoUpdatedParams>} LogObject<devCenterPublishYourAppContactInfoUpdatedParams>
 */
export function devCenterPublishYourAppContactInfoUpdated(params) {
    return { evid: 155, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterPayoutsDownloadData' event (evid: 159)
 *
 * Event description: The user downloaded the data
 *
 * @param {devCenterPayoutsDownloadDataParams} params - The parameters for this event
 * @property {GUID} app_id - app_id
 * @return {LogObject<devCenterPayoutsDownloadDataParams>} LogObject<devCenterPayoutsDownloadDataParams>
 */
export function devCenterPayoutsDownloadData(params) {
    return { evid: 159, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devWixComActionButtonClick' event (evid: 16)
 *
 * Event description: Click on 'Get Started' Button, dev.wix.com website
 *
 * @param {devWixComActionButtonClickParams} params - The parameters for this event
 * @property {string} button_name - e.g : get_started_upper , get_started_lower , explore_appmarket
 * @return {LogObject<devWixComActionButtonClickParams>} LogObject<devWixComActionButtonClickParams>
 */
export function devWixComActionButtonClick(params) {
    return { evid: 16, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterPayoutsClickToViewTransactions' event (evid: 160)
 *
 * Event description: The user navigate to transactions by clicking on the bar chart
 *
 * @param {devCenterPayoutsClickToViewTransactionsParams} params - The parameters for this event
 * @property {GUID} app_id - app_id
 * @return {LogObject<devCenterPayoutsClickToViewTransactionsParams>} LogObject<devCenterPayoutsClickToViewTransactionsParams>
 */
export function devCenterPayoutsClickToViewTransactions(params) {
    return { evid: 160, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterPayoutsSetDataRangeFilter' event (evid: 161)
 *
 * Event description: The user set a preferred date range (start month) for transactions view
 *
 * @param {devCenterPayoutsSetDataRangeFilterParams} params - The parameters for this event
 * @property {GUID} app_id - app_id
 * @property {DateTime} start_time - month-year
 * @return {LogObject<devCenterPayoutsSetDataRangeFilterParams>} LogObject<devCenterPayoutsSetDataRangeFilterParams>
 */
export function devCenterPayoutsSetDataRangeFilter(params) {
    return { evid: 161, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterMarketListingListingUpdated' event (evid: 164)
 *
 * Event description: The user saved the listing after he made changes.
 *
 * @param {devCenterMarketListingListingUpdatedParams} params - The parameters for this event
 * @property {string} fields_updated - the fields the user updated and save separeted by commas. f.e:
 * @property {string} listing_type - listing type (App Info, Media ...)
 * @property {GUID} app_id - app_id
 * @property {string} sections_updated - the sections the user updated and save separated by commas, For example: basic information,app icon,overview
 * @property {string} gtag_id - Google Tag ID
 * @return {LogObject<devCenterMarketListingListingUpdatedParams>} LogObject<devCenterMarketListingListingUpdatedParams>
 */
export function devCenterMarketListingListingUpdated(params) {
    return { evid: 164, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterMarketListingClickOnPreviewListing' event (evid: 165)
 *
 * Event description: The user clicked on preview listing
 *
 * @param {devCenterMarketListingClickOnPreviewListingParams} params - The parameters for this event
 * @property {GUID} app_id - app_id
 * @property {string} listing_type - listing type (App Info, Media ...)
 * @return {LogObject<devCenterMarketListingClickOnPreviewListingParams>} LogObject<devCenterMarketListingClickOnPreviewListingParams>
 */
export function devCenterMarketListingClickOnPreviewListing(params) {
    return { evid: 165, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterMarketListingClickOnWixLogoMakerLink' event (evid: 166)
 *
 * Event description: The user saved the listing after he made changes.
 *
 * @param {devCenterMarketListingClickOnWixLogoMakerLinkParams} params - The parameters for this event
 * @property {GUID} app_id - app_id
 * @property {string} listing_type - listing type (App Info, Media ...)
 * @return {LogObject<devCenterMarketListingClickOnWixLogoMakerLinkParams>} LogObject<devCenterMarketListingClickOnWixLogoMakerLinkParams>
 */
export function devCenterMarketListingClickOnWixLogoMakerLink(params) {
    return { evid: 166, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterPricingClickOnAddPlanButton' event (evid: 167)
 *
 * Event description: The user clicked on 'add plan'
 *
 * @param {devCenterPricingClickOnAddPlanButtonParams} params - The parameters for this event
 * @property {string} pricing_plan_id - plan id
 * @property {string} listing_type - listing type (App Info, Media ...)
 * @property {GUID} app_id - app_id
 * @return {LogObject<devCenterPricingClickOnAddPlanButtonParams>} LogObject<devCenterPricingClickOnAddPlanButtonParams>
 */
export function devCenterPricingClickOnAddPlanButton(params) {
    return { evid: 167, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterPricingClickToSaveNewPlan' event (evid: 168)
 *
 * Event description: The user clicked on 'add plan' to save new plan
 *
 * @param {devCenterPricingClickToSaveNewPlanParams} params - The parameters for this event
 * @property {string} pricing_plan_id - plan id
 * @property {number} monthly_price - monthly USD when relevant (recurring)
 * @property {string} plan_name - Plan name
 * @property {number} yearly_price - yearly USD when relevant (recurring)
 * @property {number} one_time_price - price USD when relevant (one-time)
 * @property {string} plan_type - plan type (one time, dynamic etc.)
 * @property {string} plan_benefits_format - list/paragraph
 * @property {string} product_id - product id
 * @property {GUID} app_id - app_id
 * @property {string} plan_benefits - full list or paragraph
 * @property {string} pricing_structure - pricing structure when relevant (Dynamic)
 * @return {LogObject<devCenterPricingClickToSaveNewPlanParams>} LogObject<devCenterPricingClickToSaveNewPlanParams>
 */
export function devCenterPricingClickToSaveNewPlan(params) {
    return { evid: 168, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterPricingClickOnEditPlan' event (evid: 169)
 *
 * Event description: The user clicked on the button that opens the edit modal
 *
 * @param {devCenterPricingClickOnEditPlanParams} params - The parameters for this event
 * @property {string} pricing_plan_id - plan id
 * @property {string} plan_type - plan type (dynamic etc.)
 * @property {GUID} app_id - app_id
 * @return {LogObject<devCenterPricingClickOnEditPlanParams>} LogObject<devCenterPricingClickOnEditPlanParams>
 */
export function devCenterPricingClickOnEditPlan(params) {
    return { evid: 169, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devWixComAccountProfileHover' event (evid: 17)
 *
 * Event description: Hover over profile's account name or avatar on the top right corner, dev.wix.com website.
 *
 * @param {devWixComAccountProfileHoverParams} params - The parameters for this event
 * @property {string} pageName - e.g - 'wix developers' , 'documents', etc...
 * @return {LogObject<devWixComAccountProfileHoverParams>} LogObject<devWixComAccountProfileHoverParams>
 */
export function devWixComAccountProfileHover(params) {
    return { evid: 17, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterPricingEditPlanSaved' event (evid: 170)
 *
 * Event description: Actual delete. User clicked on red button
 *
 * @param {devCenterPricingEditPlanSavedParams} params - The parameters for this event
 * @property {string} pricing_plan_id - plan id
 * @property {string} plan_type - plan type - payment (dynamic, recurring etc.)
 * @property {GUID} app_id - app_id
 * @return {LogObject<devCenterPricingEditPlanSavedParams>} LogObject<devCenterPricingEditPlanSavedParams>
 */
export function devCenterPricingEditPlanSaved(params) {
    return { evid: 170, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterPricingNavigateToPricingPage' event (evid: 171)
 *
 * Event description: The user clicked on "customize your pricing page"
 *
 * @param {devCenterPricingNavigateToPricingPageParams} params - The parameters for this event
 * @property {GUID} app_id - app_id
 * @return {LogObject<devCenterPricingNavigateToPricingPageParams>} LogObject<devCenterPricingNavigateToPricingPageParams>
 */
export function devCenterPricingNavigateToPricingPage(params) {
    return { evid: 171, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterPricingPricingPageClickOnAddPlanFeature' event (evid: 172)
 *
 * Event description: The user clicked on 'add plan feature'
 *
 * @param {devCenterPricingPricingPageClickOnAddPlanFeatureParams} params - The parameters for this event
 * @property {string} pricing_plan_id - plan id
 * @property {string} plan_type - plan type
 * @property {string} feature_name - feature name saved
 * @property {GUID} app_id - app_id
 * @return {LogObject<devCenterPricingPricingPageClickOnAddPlanFeatureParams>} LogObject<devCenterPricingPricingPageClickOnAddPlanFeatureParams>
 */
export function devCenterPricingPricingPageClickOnAddPlanFeature(params) {
    return { evid: 172, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterAppBoxClick' event (evid: 173)
 *
 * Event description: Triggered by clicking on an app in 'my apps' page
 *
 * @param {devCenterAppBoxClickParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {number} installations_num - number of installations as it appears in My Apps page
 * @property {string} last_update - the app last update date as it appears in My Apps page
 * @property {string} app_status - app status as it appears in My Apps page: Published/Draft/Submitted/etc.
 * @property {GUID} app_id - app_id
 * @property {string} app_rating - app rating as it appears in My Apps page
 * @property {string} latest_version_status - the lastest app version status as it appears in My Apps page
 * @property {string} click_type - edit-cta, row-level-click
 * @property {string} dev_ux_type - UX flavor: developer ,no-code
 *
 * @return {LogObject<devCenterAppBoxClickParams>} LogObject<devCenterAppBoxClickParams>
 */
export function devCenterAppBoxClick(params) {
    return { evid: 173, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterHeaderNavigationClick' event (evid: 174)
 *
 * Event description: Triggered by clicking on a link in the top navigation bar
 *
 * @param {devCenterHeaderNavigationClickParams} params - The parameters for this event
 * @property {string} link_name - link name
 * @property {GUID} uuid - uuid
 * @return {LogObject<devCenterHeaderNavigationClickParams>} LogObject<devCenterHeaderNavigationClickParams>
 */
export function devCenterHeaderNavigationClick(params) {
    return { evid: 174, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterManageYourAppsReviewsDeleteReply' event (evid: 175)
 *
 * Event description: User deleted a reply to a review
 *
 * @param {devCenterManageYourAppsReviewsDeleteReplyParams} params - The parameters for this event
 * @property {GUID} reply_id - reply id
 * @property {number} app_review_score - # of stars of the review
 * @property {string} app_id - app id
 * @return {LogObject<devCenterManageYourAppsReviewsDeleteReplyParams>} LogObject<devCenterManageYourAppsReviewsDeleteReplyParams>
 */
export function devCenterManageYourAppsReviewsDeleteReply(params) {
    return { evid: 175, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterPricingSavePricingSettings' event (evid: 176)
 *
 * Event description: user click 'save' in the pricing main page
 *
 * @param {devCenterPricingSavePricingSettingsParams} params - The parameters for this event
 * @property {boolean} is_free_trial - boolean
 * @property {string} pricing_page_type - (Wix pricing and checkout/External pricing page)
 * @property {string} business_model - Freemium, Premium etc.
 * @property {string} app_id - app id
 * @property {number} amount_visible_plans - how many visible plans?
 * @property {boolean} is_premium_and_domain_only - App is only available for sites with a Wix Premium plan and a domain
 * @property {number} free_trial_days - number of free trial days
 * @return {LogObject<devCenterPricingSavePricingSettingsParams>} LogObject<devCenterPricingSavePricingSettingsParams>
 */
export function devCenterPricingSavePricingSettings(params) {
    return { evid: 176, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterPricingPricingPageFeatureSave' event (evid: 177)
 *
 * Event description: user clicks on 'save' a new or existing feature
 *
 * @param {devCenterPricingPricingPageFeatureSaveParams} params - The parameters for this event
 * @property {string} pricing_plan_id - plan id
 * @property {string} feature_name - feature name
 * @property {string} app_id - app id
 * @property {string} action_type - new,edit
 * @return {LogObject<devCenterPricingPricingPageFeatureSaveParams>} LogObject<devCenterPricingPricingPageFeatureSaveParams>
 */
export function devCenterPricingPricingPageFeatureSave(params) {
    return { evid: 177, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterPricingPricingPageFeatureDeleted' event (evid: 178)
 *
 * Event description: user deletes a feature
 *
 * @param {devCenterPricingPricingPageFeatureDeletedParams} params - The parameters for this event
 * @property {string} pricing_plan_id - plan id
 * @property {string} feature_name - feature name
 * @property {string} app_id - app id
 * @return {LogObject<devCenterPricingPricingPageFeatureDeletedParams>} LogObject<devCenterPricingPricingPageFeatureDeletedParams>
 */
export function devCenterPricingPricingPageFeatureDeleted(params) {
    return { evid: 178, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterPricingPricingPageClickOnPreviewPage' event (evid: 179)
 *
 * Event description: user clicks on 'preview pricing page'
 *
 * @param {devCenterPricingPricingPageClickOnPreviewPageParams} params - The parameters for this event
 * @property {string} app_id - app id
 * @return {LogObject<devCenterPricingPricingPageClickOnPreviewPageParams>} LogObject<devCenterPricingPricingPageClickOnPreviewPageParams>
 */
export function devCenterPricingPricingPageClickOnPreviewPage(params) {
    return { evid: 179, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devWixComAccountProfileMenuClick' event (evid: 18)
 *
 * Event description: After Hovering over account profile , clicking on menu option, dev.wix.com website.
 *
 * @param {devWixComAccountProfileMenuClickParams} params - The parameters for this event
 * @property {string} menuClick - menu click name ( 'developer account', 'log out')
 * @property {string} pageName - e.g - 'wix developers' , 'documents', etc...
 * @return {LogObject<devWixComAccountProfileMenuClickParams>} LogObject<devWixComAccountProfileMenuClickParams>
 */
export function devWixComAccountProfileMenuClick(params) {
    return { evid: 18, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterMyAppsButtonClick' event (evid: 180)
 *
 * Event description: Triggered by clicking on UI buttons in 'my apps' page. Used for 'create new app' CTA
 *
 * @param {devCenterMyAppsButtonClickParams} params - The parameters for this event
 * @property {string} location - location of the button (context)
 * @property {GUID} uuid - uuid
 * @property {string} button_name - the name of the button (with additional context if needed)
 * @property {string} cta_name - name of the action
 * @property {GUID} app_id - app id
 * @property {string} dev_ux_type - ux flavor (developer, no-code)
 * @return {LogObject<devCenterMyAppsButtonClickParams>} LogObject<devCenterMyAppsButtonClickParams>
 */
export function devCenterMyAppsButtonClick(params) {
    return { evid: 180, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'appTemplatesPageLoaded' event (evid: 200)
 *
 * Event description: Triggered by any load of a page/modal.
 *
 * @param {appTemplatesPageLoadedParams} params - The parameters for this event
 * @property {string} to_url - The URL of the page where the click is send the user to
 * @property {string} page_title - The title of the page
 * @property {string} from_url - The URL of the page where the click is located
 * @property {string} page_name - The name of the page/modal
 * @property {string} page_type - Page or modal
 * @return {LogObject<appTemplatesPageLoadedParams>} LogObject<appTemplatesPageLoadedParams>
 */
export function appTemplatesPageLoaded(params) {
    return { evid: 200, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'appTemplatesUserClicked' event (evid: 201)
 *
 * Event description: Triggered by UI clicks in 'App Templates' environment.
 *
 * @param {appTemplatesUserClickedParams} params - The parameters for this event
 * @property {string} click_name - The name of the action or destination
 * @property {string} click_type - What does the click do?
 * @property {string} guid_type - The id type of relevant  the entity (template_id,app_id)
 * @property {string} to_url - The URL of the page where the click is send the user to
 * @property {string} from_url - The URL of the page where the click is located
 * @property {GUID} guid_value - The id  of relevant  the entity
 * @return {LogObject<appTemplatesUserClickedParams>} LogObject<appTemplatesUserClickedParams>
 */
export function appTemplatesUserClicked(params) {
    return { evid: 201, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterOpenTokenModalClick' event (evid: 29)
 *
 * Event description: User clicks on 'token' button
 *
 * @param {devCenterOpenTokenModalClickParams} params - The parameters for this event
 * @property {boolean} isTokenExist - token already generated - true / false
 * @property {string} origin - "playground","main_header"
 * @return {LogObject<devCenterOpenTokenModalClickParams>} LogObject<devCenterOpenTokenModalClickParams>
 */
export function devCenterOpenTokenModalClick(params) {
    return { evid: 29, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devWixComLogInToDeveloperCenter' event (evid: 31)
 *
 * Event description: When a wix user, or a new signed up user is logged in into dev.wix.com.
 *
 * @param {devWixComLogInToDeveloperCenterParams} params - The parameters for this event
 * @return {LogObject<devWixComLogInToDeveloperCenterParams>} LogObject<devWixComLogInToDeveloperCenterParams>
 */
export function devWixComLogInToDeveloperCenter(params) {
    return { evid: 31, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterDynamicDashboardDashboardOpened' event (evid: 32)
 *
 * Event description: In the developer center, the dashboard of an app is being opened by a developer.
 *
 * @param {devCenterDynamicDashboardDashboardOpenedParams} params - The parameters for this event
 * @property {string} step_name - name of main step that opened the dashboard (main, add_info, collect_rev, almost_done etc...)
 * @property {string} app_type - type of app being developed ( 'integration_app' or 'visual_app')
 * @property {GUID} appId - app_id
 * @return {LogObject<devCenterDynamicDashboardDashboardOpenedParams>} LogObject<devCenterDynamicDashboardDashboardOpenedParams>
 */
export function devCenterDynamicDashboardDashboardOpened(params) {
    return { evid: 32, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterDynamicDashboardExpandStep' event (evid: 33)
 *
 * Event description: In the developer center, user clicks on steps offered by the dynamic dashboard. clicking on the steps will expand them for more information and call to action button
 *
 * @param {devCenterDynamicDashboardExpandStepParams} params - The parameters for this event
 * @property {string} step_name - step name inside the dynamic dashboard
 * @property {string} expand_reason - step was expand because ('url_visit','direct_click')
 * @property {string} app_type - type of app being developed ( 'integration_app' or 'visual_app')
 * @property {GUID} appId - app_id
 * @return {LogObject<devCenterDynamicDashboardExpandStepParams>} LogObject<devCenterDynamicDashboardExpandStepParams>
 */
export function devCenterDynamicDashboardExpandStep(params) {
    return { evid: 33, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterDynamicDashboardCallToAction' event (evid: 34)
 *
 * Event description: In the developer center, user clicks on steps offered by the dashboard.  each step offered has a unique call to action button that will help the developer to make progress.
 *
 * @param {devCenterDynamicDashboardCallToActionParams} params - The parameters for this event
 * @property {string} step_name - [OLD DASHBOARD] in the dashboard steps, user clicks on the button that calls for action (e.g - add app info)
 * @property {string} app_type - type of app being developed ( 'integration_app' or 'visual_app')
 * @property {GUID} appId - app_id
 * @property {string} section - the section where the Call to Action (CTA) is located
 * @property {string} to_page_name - The destination page
 * @property {string} to_url - the destination url (internal and external)
 * @property {string} cta_name - The name of the cta click
 * @return {LogObject<devCenterDynamicDashboardCallToActionParams>} LogObject<devCenterDynamicDashboardCallToActionParams>
 */
export function devCenterDynamicDashboardCallToAction(params) {
    return { evid: 34, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterDynamicDashboardSideboxClick' event (evid: 35)
 *
 * Event description: In the developer center, the dashboard of an app is being opened by a developer - there is a small help sidebox on the side with options to click. clicking on those options will trigger this event.
 *
 * @param {devCenterDynamicDashboardSideboxClickParams} params - The parameters for this event
 * @property {string} app_type - type of app being developed ( 'integration_app' or 'visual_app')
 * @property {string} sidebox_name - sidebox button that offer more features to developers
 * @property {GUID} appId - app_id
 * @return {LogObject<devCenterDynamicDashboardSideboxClickParams>} LogObject<devCenterDynamicDashboardSideboxClickParams>
 */
export function devCenterDynamicDashboardSideboxClick(params) {
    return { evid: 35, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterPreviewAppClick' event (evid: 36)
 *
 * Event description: Developer clicks on 'Preview App' in order to review his app listing in the market.
 *
 * @param {devCenterPreviewAppClickParams} params - The parameters for this event
 * @property {GUID} appId - app_id
 * @property {string} loaction - location
 * @return {LogObject<devCenterPreviewAppClickParams>} LogObject<devCenterPreviewAppClickParams>
 */
export function devCenterPreviewAppClick(params) {
    return { evid: 36, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterCompanyInfoUpdated' event (evid: 37)
 *
 * Event description: company info edited and saved
 *
 * @param {devCenterCompanyInfoUpdatedParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} app_id - app_id
 * @return {LogObject<devCenterCompanyInfoUpdatedParams>} LogObject<devCenterCompanyInfoUpdatedParams>
 */
export function devCenterCompanyInfoUpdated(params) {
    return { evid: 37, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterNavigationPageView' event (evid: 38)
 *
 * Event description: Navigating between different pages in the Dev Center
 *
 * @param {devCenterNavigationPageViewParams} params - The parameters for this event
 * @property {string} referralAdditionalInfo - referral came from email? outside link? inside navigation?
 * @property {string} pageName - name of page viewed by developer
 * @property {GUID} appId - app_id
 * @return {LogObject<devCenterNavigationPageViewParams>} LogObject<devCenterNavigationPageViewParams>
 */
export function devCenterNavigationPageView(params) {
    return { evid: 38, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterPageView' event (evid: 41)
 *
 * Event description: Page was loaded to user
 *
 * @param {devCenterPageViewParams} params - The parameters for this event
 * @property {string} page_name - name of page
 * @property {GUID} app_id - app_id
 * @property {string} route - the page's route
 *
 * @property {string} page_content - the content of the page that was rendered
 * @return {LogObject<devCenterPageViewParams>} LogObject<devCenterPageViewParams>
 */
export function devCenterPageView(params) {
    return { evid: 41, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterTransactionHistoryPageView' event (evid: 42)
 *
 * Event description: user view the 'transaction history' page
 *
 * @param {devCenterTransactionHistoryPageViewParams} params - The parameters for this event
 * @property {string} label_name - name of label
 * @property {string} origin - tooltip or button
 * @property {GUID} app_id - app id
 * @return {LogObject<devCenterTransactionHistoryPageViewParams>} LogObject<devCenterTransactionHistoryPageViewParams>
 */
export function devCenterTransactionHistoryPageView(params) {
    return { evid: 42, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterPayoutDashboardDownloadCsvFileClick' event (evid: 43)
 *
 * Event description: user clicks on 'download csv file' button
 *
 * @param {devCenterPayoutDashboardDownloadCsvFileClickParams} params - The parameters for this event
 * @property {string} start_date - start date
 * @property {string} end_date - end date
 * @property {GUID} app_id - app_id
 * @return {LogObject<devCenterPayoutDashboardDownloadCsvFileClickParams>} LogObject<devCenterPayoutDashboardDownloadCsvFileClickParams>
 */
export function devCenterPayoutDashboardDownloadCsvFileClick(params) {
    return { evid: 43, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterReviewsLearnMoreClick' event (evid: 44)
 *
 * Event description: user clicks on learn more
 *
 * @param {devCenterReviewsLearnMoreClickParams} params - The parameters for this event
 * @property {GUID} app_Id - app_id
 * @return {LogObject<devCenterReviewsLearnMoreClickParams>} LogObject<devCenterReviewsLearnMoreClickParams>
 */
export function devCenterReviewsLearnMoreClick(params) {
    return { evid: 44, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterDashboardClickOnBackToMyApps' event (evid: 50)
 *
 * Event description: In the dashboard page when the user clicks on  Back To My Apps Button.
 *
 * @param {devCenterDashboardClickOnBackToMyAppsParams} params - The parameters for this event
 * @property {GUID} app_id - app id
 * @property {string} location_name - If the user clicked from the main dashboard or from the sections
 * @return {LogObject<devCenterDashboardClickOnBackToMyAppsParams>} LogObject<devCenterDashboardClickOnBackToMyAppsParams>
 */
export function devCenterDashboardClickOnBackToMyApps(params) {
    return { evid: 50, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterDashboardClickOnWixTpa' event (evid: 51)
 *
 * Event description: In the dashboard page when the user clicks on  Back To My Apps Button.
 *
 * @param {devCenterDashboardClickOnWixTpaParams} params - The parameters for this event
 * @property {GUID} app_id - app id
 * @property {boolean} is_clicked - if the user clicked on the button Wix TPA- (if he clicked than 1, if he canceled 0, if not clicked null)
 * @return {LogObject<devCenterDashboardClickOnWixTpaParams>} LogObject<devCenterDashboardClickOnWixTpaParams>
 */
export function devCenterDashboardClickOnWixTpa(params) {
    return { evid: 51, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterDashboardHoverOnTestYourApp' event (evid: 52)
 *
 * Event description: The User Hovers On test your app from the dashboard or dashboard slide bar sections.
 *
 * @param {devCenterDashboardHoverOnTestYourAppParams} params - The parameters for this event
 * @property {number} num_of_dev_sites - num_of_dev_sites
 * @property {string} loaction - the location of the hovering (main dashboard, Components section...)
 * @property {boolean} has_wix_site - Does the user has a Wix site or not
 * @property {GUID} app_id - app id
 * @return {LogObject<devCenterDashboardHoverOnTestYourAppParams>} LogObject<devCenterDashboardHoverOnTestYourAppParams>
 */
export function devCenterDashboardHoverOnTestYourApp(params) {
    return { evid: 52, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterMyAppsChooseApp' event (evid: 53)
 *
 * Event description: User visits the Dev Center My Apps and clicks on specific app.
 *
 * @param {devCenterMyAppsChooseAppParams} params - The parameters for this event
 * @property {GUID} app_id - app id
 * @return {LogObject<devCenterMyAppsChooseAppParams>} LogObject<devCenterMyAppsChooseAppParams>
 */
export function devCenterMyAppsChooseApp(params) {
    return { evid: 53, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterDashboardClickOnTestYourApp' event (evid: 54)
 *
 * Event description: The user clicks on 'Create Site' or on one of the entry points in the popover menu of 'Test Your App'.
 *
 * @param {devCenterDashboardClickOnTestYourAppParams} params - The parameters for this event
 * @property {boolean} is_sites_limit - Did the developer reach the number of test sites limit
 * @property {string} test_name - app market, editor, dashboard
 * @property {string} click_type - entry point/create site
 * @property {string} loaction - the location of the click (main dashboard, Components section...)
 * @property {GUID} app_id - app id
 * @property {number} number_of_dev_sites - How many sites does the developer already have
 * @return {LogObject<devCenterDashboardClickOnTestYourAppParams>} LogObject<devCenterDashboardClickOnTestYourAppParams>
 */
export function devCenterDashboardClickOnTestYourApp(params) {
    return { evid: 54, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterDashboardBuildYourAppClickOnComponent' event (evid: 55)
 *
 * Event description: In the Build Your App  - Components page when the user clicks on  existing component.
 *
 * @param {devCenterDashboardBuildYourAppClickOnComponentParams} params - The parameters for this event
 * @property {string} component_name - dashboard, website, integration
 * @property {string} built_on - where the component was built on: devcenter/blocks/cli for apps
 * @property {GUID} app_id - app id
 * @property {string} component_id - component ID
 * @property {string} component_type - the type of the specific component for example - website: page, worker...
 * @return {LogObject<devCenterDashboardBuildYourAppClickOnComponentParams>} LogObject<devCenterDashboardBuildYourAppClickOnComponentParams>
 */
export function devCenterDashboardBuildYourAppClickOnComponent(params) {
    return { evid: 55, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterDashboardBuildYourAppHoverOnAddComponent' event (evid: 56)
 *
 * Event description: In the Build Your App  - Components page when the user hover on  add new component button.
 *
 * @param {devCenterDashboardBuildYourAppHoverOnAddComponentParams} params - The parameters for this event
 * @property {boolean} is_wix_app - true = internal app, false = TPA's app
 * @property {string} app_status - current status : DECLINED / PUBLISHED / IN_REVIEW / SUBMITTED / APPROVED / DRAFT
 * @property {GUID} app_id - app id
 * @return {LogObject<devCenterDashboardBuildYourAppHoverOnAddComponentParams>} LogObject<devCenterDashboardBuildYourAppHoverOnAddComponentParams>
 */
export function devCenterDashboardBuildYourAppHoverOnAddComponent(params) {
    return { evid: 56, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterDashboardBuildYourAppClickOnAddComponent' event (evid: 57)
 *
 * Event description: deprecated on September 2023, 96:9620 replacing this event (being triggered when user clicks on create component or submit a proposal)
 *
 * @param {devCenterDashboardBuildYourAppClickOnAddComponentParams} params - The parameters for this event
 * @property {string} component_name - dashboard, website, integration
 * @property {GUID} app_id - app id
 * @property {string} component_type - page / widget etc.
 * @return {LogObject<devCenterDashboardBuildYourAppClickOnAddComponentParams>} LogObject<devCenterDashboardBuildYourAppClickOnAddComponentParams>
 */
export function devCenterDashboardBuildYourAppClickOnAddComponent(params) {
    return { evid: 57, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterDashboardBuildYourAppOauthClickOnSave' event (evid: 58)
 *
 * Event description: In the  Build Your App  - OAuth page when the user clicks on save.
 *
 * @param {devCenterDashboardBuildYourAppOauthClickOnSaveParams} params - The parameters for this event
 * @property {GUID} app_id - app id
 * @return {LogObject<devCenterDashboardBuildYourAppOauthClickOnSaveParams>} LogObject<devCenterDashboardBuildYourAppOauthClickOnSaveParams>
 */
export function devCenterDashboardBuildYourAppOauthClickOnSave(params) {
    return { evid: 58, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterDashboardBuildYourAppOauthClickOnAppUrlBehavior' event (evid: 59)
 *
 * Event description: In the  Build Your App  - OAuth page when the user clicks on App URL Behavior.
 *
 * @param {devCenterDashboardBuildYourAppOauthClickOnAppUrlBehaviorParams} params - The parameters for this event
 * @property {string} behavior_name - Open App URL in new tab (Recommended), Or Open App URL in new window
 * @property {GUID} app_id - app id
 * @property {number} behavior_index - the index 0 or 1
 * @return {LogObject<devCenterDashboardBuildYourAppOauthClickOnAppUrlBehaviorParams>} LogObject<devCenterDashboardBuildYourAppOauthClickOnAppUrlBehaviorParams>
 */
export function devCenterDashboardBuildYourAppOauthClickOnAppUrlBehavior(params) {
    return { evid: 59, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterDashboardBuildYourAppPermissionsClickOnAddPermission' event (evid: 60)
 *
 * Event description: In the  Build Your App  - Permissions page when the user clicks on AAdd Permission Button.
 *
 * @param {devCenterDashboardBuildYourAppPermissionsClickOnAddPermissionParams} params - The parameters for this event
 * @property {GUID} app_id - app id
 * @property {string} platform - platform
 * @return {LogObject<devCenterDashboardBuildYourAppPermissionsClickOnAddPermissionParams>} LogObject<devCenterDashboardBuildYourAppPermissionsClickOnAddPermissionParams>
 */
export function devCenterDashboardBuildYourAppPermissionsClickOnAddPermission(params) {
    return { evid: 60, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterDashboardBuildYourAppWebhooksApiCategory' event (evid: 61)
 *
 * Event description: In the  Build Your App  - Webhooks page after the user clicks on Add Webhook Button what API Category he chose.
 *
 * @param {devCenterDashboardBuildYourAppWebhooksApiCategoryParams} params - The parameters for this event
 * @property {string} api_category - Wix Stores, Marketing...
 * @property {GUID} app_id - app id
 * @return {LogObject<devCenterDashboardBuildYourAppWebhooksApiCategoryParams>} LogObject<devCenterDashboardBuildYourAppWebhooksApiCategoryParams>
 */
export function devCenterDashboardBuildYourAppWebhooksApiCategory(params) {
    return { evid: 61, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterPublishedAppDashboardPageDashboardOpened' event (evid: 62)
 *
 * Event description: In the developer center, the dashboard of a published app is being opened by a developer.
 *
 * @param {devCenterPublishedAppDashboardPageDashboardOpenedParams} params - The parameters for this event
 * @property {string} app_type - type of app being developed ( 'integration_app' or 'visual_app')
 * @property {GUID} app_id - app_id
 * @return {LogObject<devCenterPublishedAppDashboardPageDashboardOpenedParams>} LogObject<devCenterPublishedAppDashboardPageDashboardOpenedParams>
 */
export function devCenterPublishedAppDashboardPageDashboardOpened(params) {
    return { evid: 62, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterPublishedAppDashboardPageCallToAction' event (evid: 63)
 *
 * Event description: In the developer center, a published app clicks on steps offered by the dynamic dashboard.  each step offered has a unique call to action button that will help the developer to make progress.
 *
 * @param {devCenterPublishedAppDashboardPageCallToActionParams} params - The parameters for this event
 * @property {string} app_type - type of app being developed ( 'integration_app' or 'visual_app')
 * @property {string} cta_name - in the dynamic dashboard steps, user clicks on the button that calls for action (e.g - add app info)
 * @property {GUID} appId - app_id
 * @return {LogObject<devCenterPublishedAppDashboardPageCallToActionParams>} LogObject<devCenterPublishedAppDashboardPageCallToActionParams>
 */
export function devCenterPublishedAppDashboardPageCallToAction(params) {
    return { evid: 63, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterDashboardBuildYourAppWebhooksAddWebhook' event (evid: 64)
 *
 * Event description: In the  Build Your App  - Webhooks page when the user clicks on Add Webhook Button .
 *
 * @param {devCenterDashboardBuildYourAppWebhooksAddWebhookParams} params - The parameters for this event
 * @property {string} loaction - the location the user clicked on "add webhook". The values changed in 2/2023: top--> Set up webhook CTA, bottom--> Empty state
 * @property {boolean} is_wix_app - [DEPRECATE]
 * is_wix_app
 * @property {string} app_status - [DEPRECATE]
 * app_status
 * @property {number} num_webhooks - [DEPRECATE]
 * num_webhooks
 * @property {GUID} app_id - app id
 * @return {LogObject<devCenterDashboardBuildYourAppWebhooksAddWebhookParams>} LogObject<devCenterDashboardBuildYourAppWebhooksAddWebhookParams>
 */
export function devCenterDashboardBuildYourAppWebhooksAddWebhook(params) {
    return { evid: 64, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterManageYourAppReviewsDownloadCsvClick' event (evid: 81)
 *
 * Event description: In the Manage Your App - Reviews - Download CSV  reviews Click
 *
 * @param {devCenterManageYourAppReviewsDownloadCsvClickParams} params - The parameters for this event
 * @property {string} app_id - app id
 * @return {LogObject<devCenterManageYourAppReviewsDownloadCsvClickParams>} LogObject<devCenterManageYourAppReviewsDownloadCsvClickParams>
 */
export function devCenterManageYourAppReviewsDownloadCsvClick(params) {
    return { evid: 81, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterManageYourAppReviewsViewReviewClick' event (evid: 82)
 *
 * Event description: In the Manage Your App - Reviews - View Review Click
 *
 * @param {devCenterManageYourAppReviewsViewReviewClickParams} params - The parameters for this event
 * @property {string} app_id - app id
 * @property {boolean} is_selected - true = open, close = false
 * @return {LogObject<devCenterManageYourAppReviewsViewReviewClickParams>} LogObject<devCenterManageYourAppReviewsViewReviewClickParams>
 */
export function devCenterManageYourAppReviewsViewReviewClick(params) {
    return { evid: 82, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterManageYourAppReviewsPostReplyClick' event (evid: 83)
 *
 * Event description: Dev Center - Manage Your App - Reviews -Post Reply Click.
 *
 * @param {devCenterManageYourAppReviewsPostReplyClickParams} params - The parameters for this event
 * @property {string} app_id - app id
 * @property {string} reply_type - new/edit
 * @return {LogObject<devCenterManageYourAppReviewsPostReplyClickParams>} LogObject<devCenterManageYourAppReviewsPostReplyClickParams>
 */
export function devCenterManageYourAppReviewsPostReplyClick(params) {
    return { evid: 83, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterManageYourAppStatsDetailsOrOverviewClick' event (evid: 86)
 *
 * Event description: Dev Center - Manage Your App - Stats - Click on Tab to Navigate.
 *
 * @param {devCenterManageYourAppStatsDetailsOrOverviewClickParams} params - The parameters for this event
 * @property {string} loaction - Details or Overview
 * @property {string} app_id - app id
 * @return {LogObject<devCenterManageYourAppStatsDetailsOrOverviewClickParams>} LogObject<devCenterManageYourAppStatsDetailsOrOverviewClickParams>
 */
export function devCenterManageYourAppStatsDetailsOrOverviewClick(params) {
    return { evid: 86, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterManageYourAppTeamMembersAddTeamMemberClick' event (evid: 88)
 *
 * Event description: In the Manage Your App - Team Members- Add team member Click
 *
 * @param {devCenterManageYourAppTeamMembersAddTeamMemberClickParams} params - The parameters for this event
 * @property {string} app_id - app id
 * @return {LogObject<devCenterManageYourAppTeamMembersAddTeamMemberClickParams>} LogObject<devCenterManageYourAppTeamMembersAddTeamMemberClickParams>
 */
export function devCenterManageYourAppTeamMembersAddTeamMemberClick(params) {
    return { evid: 88, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterManageYourAppTeamMembersSendInviteClick' event (evid: 89)
 *
 * Event description: Manage Your App - Team Members - Send Invite Click
 *
 * @param {devCenterManageYourAppTeamMembersSendInviteClickParams} params - The parameters for this event
 * @property {string} app_id - app id
 * @return {LogObject<devCenterManageYourAppTeamMembersSendInviteClickParams>} LogObject<devCenterManageYourAppTeamMembersSendInviteClickParams>
 */
export function devCenterManageYourAppTeamMembersSendInviteClick(params) {
    return { evid: 89, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterManageYourAppTeamMembersCopyLinkClick' event (evid: 90)
 *
 * Event description: Manage Your App - Team Members - Copy Link Click
 *
 * @param {devCenterManageYourAppTeamMembersCopyLinkClickParams} params - The parameters for this event
 * @property {string} app_id - app id
 * @property {string} entryPoint - the page the user copy the link from: collaborators/my apps
 * @property {string} dev_ux_type - UX flavor: developer ,no-code
 *
 * @return {LogObject<devCenterManageYourAppTeamMembersCopyLinkClickParams>} LogObject<devCenterManageYourAppTeamMembersCopyLinkClickParams>
 */
export function devCenterManageYourAppTeamMembersCopyLinkClick(params) {
    return { evid: 90, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterDashboardBuildYourAppOauthClickOnCopy' event (evid: 91)
 *
 * Event description: Dashboard - Build Your App - OAuth - Click On Copy
 *
 * @param {devCenterDashboardBuildYourAppOauthClickOnCopyParams} params - The parameters for this event
 * @property {string} app_id - app id
 * @return {LogObject<devCenterDashboardBuildYourAppOauthClickOnCopyParams>} LogObject<devCenterDashboardBuildYourAppOauthClickOnCopyParams>
 */
export function devCenterDashboardBuildYourAppOauthClickOnCopy(params) {
    return { evid: 91, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterDashboardBuildYourAppOauthClickOnShow' event (evid: 92)
 *
 * Event description: Dashboard - Build Your App - OAuth - Click On Show
 *
 * @param {devCenterDashboardBuildYourAppOauthClickOnShowParams} params - The parameters for this event
 * @property {string} app_id - app id
 * @property {boolean} is_selected - show = true \ hide = false
 * @return {LogObject<devCenterDashboardBuildYourAppOauthClickOnShowParams>} LogObject<devCenterDashboardBuildYourAppOauthClickOnShowParams>
 */
export function devCenterDashboardBuildYourAppOauthClickOnShow(params) {
    return { evid: 92, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterReadTheAppGuidelines' event (evid: 93)
 *
 * Event description: any click inside the stepper menu
 *
 * @param {devCenterReadTheAppGuidelinesParams} params - The parameters for this event
 * @property {string} app_id - app id
 * @property {string} click_type - the name of the button
 * @return {LogObject<devCenterReadTheAppGuidelinesParams>} LogObject<devCenterReadTheAppGuidelinesParams>
 */
export function devCenterReadTheAppGuidelines(params) {
    return { evid: 93, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterReadTheAppGuidelinesSaveClick' event (evid: 94)
 *
 * Event description: click on save in Read the App Guidelines
 *
 * @param {devCenterReadTheAppGuidelinesSaveClickParams} params - The parameters for this event
 * @property {string} app_id - app id
 * @return {LogObject<devCenterReadTheAppGuidelinesSaveClickParams>} LogObject<devCenterReadTheAppGuidelinesSaveClickParams>
 */
export function devCenterReadTheAppGuidelinesSaveClick(params) {
    return { evid: 94, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterSubmitYourApp' event (evid: 95)
 *
 * Event description: click on Submit your app button to open app submit form
 *
 * @param {devCenterSubmitYourAppParams} params - The parameters for this event
 * @property {string} location - page / tab
 * @property {GUID} uuid - uuid
 * @property {string} app_id - app id
 * @property {string} location_section - specific location in page/tab
 * @property {string} action - submit/publish
 * @return {LogObject<devCenterSubmitYourAppParams>} LogObject<devCenterSubmitYourAppParams>
 */
export function devCenterSubmitYourApp(params) {
    return { evid: 95, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterDashboardClickOnLearnMore' event (evid: 96)
 *
 * Event description: Click On Learn More on Any Page
 *
 * @param {devCenterDashboardClickOnLearnMoreParams} params - The parameters for this event
 * @property {string} target_url - target url of the kb
 * @property {string} loaction - components, oath, permission etc.
 * @property {string} app_id - app id
 * @property {string} location_section - specific area in the page
 * @property {string} click_name - the name of the click (learn more, etc...)
 * @property {string} dev_ux_type - ux flavor (developer, no-code)
 * @return {LogObject<devCenterDashboardClickOnLearnMoreParams>} LogObject<devCenterDashboardClickOnLearnMoreParams>
 */
export function devCenterDashboardClickOnLearnMore(params) {
    return { evid: 96, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'developerCenterAirflowJobsMonitoring' event (evid: 9600)
 *
 * Event description: This event helps the dev center to make sure there are no issues with Airflow sent jobs. when Airflow is not sending new data , this event should trigger an alert in Grafana or any other alerting method.
 *
 * @param {developerCenterAirflowJobsMonitoringParams} params - The parameters for this event
 * @property {number} metric_value - Airflow Job Metric value
 * @property {string} metric_name - Airflow Job Metric name
 * @return {LogObject<developerCenterAirflowJobsMonitoringParams>} LogObject<developerCenterAirflowJobsMonitoringParams>
 */
export function developerCenterAirflowJobsMonitoring(params) {
    return { evid: 9600, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterDashboardBuildYourAppChooseComponentCategory' event (evid: 9601)
 *
 * Event description: In the Build Your App  - Components page - after the user hover on add new component button- will be sent when he clicks on the wanted category. was deprecated on 15/08/23 due to removing the categories and changing add component flow.
 *
 * @param {devCenterDashboardBuildYourAppChooseComponentCategoryParams} params - The parameters for this event
 * @property {string} component_category - Dashboard / Website /Integration / TBD
 * @property {boolean} is_wix_app - true = internal app, false = TPA's app
 * @property {string} app_status - current status : DECLINED / PUBLISHED / IN_REVIEW / SUBMITTED / APPROVED / DRAFT
 * @property {GUID} app_id - app id
 * @return {LogObject<devCenterDashboardBuildYourAppChooseComponentCategoryParams>} LogObject<devCenterDashboardBuildYourAppChooseComponentCategoryParams>
 */
export function devCenterDashboardBuildYourAppChooseComponentCategory(params) {
    return { evid: 9601, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterDashboardBuildYourAppAddComponentEnd' event (evid: 9602)
 *
 * Event description: In the Build Your App  - Components page - after the user choose the component type he wants to add -how did the "add component" process end?
 *
 * @param {devCenterDashboardBuildYourAppAddComponentEndParams} params - The parameters for this event
 * @property {string} step_name - Settings / Add Components
 * @property {number} duration - duration in ms from first typing in the page  till the user ended the process and clicked on "save"
 * @property {string} component_category - Dashboard / Website /Integration / TBD
 * @property {boolean} is_wix_app - true = internal app, false = TPA's app
 * @property {boolean} is_json_editor - will get 'true' when the component type uses Json Editor
 * @property {string} origin - Where was the process-end made from? "Save button", "Cancel button", "Navigation"
 * @property {string} app_status - current status : DECLINED / PUBLISHED / IN_REVIEW / SUBMITTED / APPROVED / DRAFT
 * @property {GUID} app_id - app id
 * @property {string} end_type - What kind of end did the user chose from the origin:  "Save changes - succeeded", "Save changes - failure", "Drop changes" (navigated or cancelled and discard changes), "No changes", "Unknown" (for navigation from sidebar)
 * @property {string} component_id - a unique identifier
 * @property {string} component_type - page / widget / dashboard etc.
 * @property {string} fields_values - A Json field with the values the user typed in the different component's fields : {"Field 1 Name": "Field 1 Value", "Field 2 Name": "Field 2 Value"}.
 * @property {string} action_type - "edit" for editing existing component, "create" for creating new component
 * @return {LogObject<devCenterDashboardBuildYourAppAddComponentEndParams>} LogObject<devCenterDashboardBuildYourAppAddComponentEndParams>
 */
export function devCenterDashboardBuildYourAppAddComponentEnd(params) {
    return { evid: 9602, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterDashboardBuildYourAppStartTypeInJasonEditor' event (evid: 9603)
 *
 * Event description: In the Build Your App  - Components page - after the user chose to add "data extension" component - what type of entity he wants to add?
 *
 * @param {devCenterDashboardBuildYourAppStartTypeInJasonEditorParams} params - The parameters for this event
 * @property {string} entity_owner - The vertical/horizontal that exposed this entity
 * @property {string} component_category - Integration
 * @property {boolean} is_wix_app - true = internal app, false = TPA's app
 * @property {string} entity_name - The entity name (subtitle)
 * @property {string} app_status - current status : DECLINED / PUBLISHED / IN_REVIEW / SUBMITTED / APPROVED / DRAFT
 * @property {GUID} app_id - app id
 * @property {string} component_id - (Edit mode) a unique identifier
 * @property {string} component_type - Data extension
 * @return {LogObject<devCenterDashboardBuildYourAppStartTypeInJasonEditorParams>} LogObject<devCenterDashboardBuildYourAppStartTypeInJasonEditorParams>
 */
export function devCenterDashboardBuildYourAppStartTypeInJasonEditor(params) {
    return { evid: 9603, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterDashboardBuildYourAppErrorsInJasonEditor' event (evid: 9604)
 *
 * Event description: In the Build Your App  - Components page - when the user gets an error toast after he tried to save his changes in the Json Editor window (for component types that use Json Editor)
 *
 * @param {devCenterDashboardBuildYourAppErrorsInJasonEditorParams} params - The parameters for this event
 * @property {string} error_origin - server validation / schema validation
 * @property {string} component_category - Dashboard / Website /Integration / TBD
 * @property {boolean} is_wix_app - true = internal app, false = TPA's app
 * @property {string} error_type - the error content in english (as it shown in the toast)
 * @property {string} app_status - current status : DECLINED / PUBLISHED / IN_REVIEW / SUBMITTED / APPROVED / DRAFT
 * @property {GUID} app_id - app id
 * @property {string} component_id - (Edit mode) a unique identifier
 * @property {string} component_type - page / widget / dashboard etc.
 * @return {LogObject<devCenterDashboardBuildYourAppErrorsInJasonEditorParams>} LogObject<devCenterDashboardBuildYourAppErrorsInJasonEditorParams>
 */
export function devCenterDashboardBuildYourAppErrorsInJasonEditor(params) {
    return { evid: 9604, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'dcBuildInstallationSettingsClick' event (evid: 9606)
 *
 * Event description: In the Build Your App - Components page - fires when the user clicks on installation settings of the app
 *
 * @param {dcBuildInstallationSettingsClickParams} params - The parameters for this event
 * @property {string} built_on - where the component was built on: devcenter/blocks/cli for apps. relevant since september 23
 * @property {string} component_category - Dashboard / Website /Integration / TBD
 * @property {boolean} is_wix_app - true = internal app, false = TPA's app
 * @property {string} app_status - current status: DECLINED / PUBLISHED / IN_REVIEW / SUBMITTED / APPROVED / DRAFT
 * @property {GUID} app_id - app id
 * @property {string} component_id - the component unique identifier
 * @property {string} component_type - page / widget / dashboard / blocks etc.
 * @return {LogObject<dcBuildInstallationSettingsClickParams>} LogObject<dcBuildInstallationSettingsClickParams>
 */
export function dcBuildInstallationSettingsClick(params) {
    return { evid: 9606, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'dcBuildInstallationSettingsAction' event (evid: 9607)
 *
 * Event description: In the Build Your App - Components page - fires when the user clicks on any action in the app installation settings page
 *
 * @param {dcBuildInstallationSettingsActionParams} params - The parameters for this event
 * @property {string} step - {installation_method, add_panel_show, desktop_preset, mobile_preset, page_name, page_id, widget_size}
 * @property {string} component_category - Dashboard / Website /Integration / TBD
 * @property {boolean} is_wix_app - true = internal app, false = TPA's app
 * @property {string} app_status - current status: DECLINED / PUBLISHED / IN_REVIEW / SUBMITTED / APPROVED / DRAFT
 * @property {GUID} app_id - app id
 * @property {string} component_id - the component unique identifier
 * @property {string} component_type - page / widget / dashboard / blocks etc.
 * @property {string} action - the action taken for each step
 * @return {LogObject<dcBuildInstallationSettingsActionParams>} LogObject<dcBuildInstallationSettingsActionParams>
 */
export function dcBuildInstallationSettingsAction(params) {
    return { evid: 9607, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterWebhooksDeleteOrEditWebhook' event (evid: 9610)
 *
 * Event description: In the  Build Your App  - Webhooks page after the user clicks on delete webhook / edit callback from the subscriptions table - the action the user chose on the opened modal
 *
 * @param {devCenterWebhooksDeleteOrEditWebhookParams} params - The parameters for this event
 * @property {string} action_name - What action did the user choose to do in the opened modal: Delete webhook / Edit callback
 * @property {string} event_name - [DEPRECATE]
 * event_name
 * @property {boolean} is_wix_app - [DEPRECATE]
 * is_wix_app
 * @property {string} app_status - [DEPRECATE]
 * app_status
 * @property {string} category - [DEPRECATE]
 * category
 * @property {GUID} app_id - app id
 * @property {string} slug - slug
 * @return {LogObject<devCenterWebhooksDeleteOrEditWebhookParams>} LogObject<devCenterWebhooksDeleteOrEditWebhookParams>
 */
export function devCenterWebhooksDeleteOrEditWebhook(params) {
    return { evid: 9610, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterSaveChangesInSpec' event (evid: 9611)
 *
 * Event description: When user save changes in spec that connected to component after editing the spec
 *
 * @param {devCenterSaveChangesInSpecParams} params - The parameters for this event
 * @property {string} app_status - current status : DECLINED / PUBLISHED / IN_REVIEW / SUBMITTED / APPROVED / DRAFT
 * @property {GUID} app_id - app id
 * @property {string} component_id - (only for Edit) a unique identifier
 * @property {string} component_type - page / widget / dashboard etc.
 * @return {LogObject<devCenterSaveChangesInSpecParams>} LogObject<devCenterSaveChangesInSpecParams>
 */
export function devCenterSaveChangesInSpec(params) {
    return { evid: 9611, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterWhenUserRemoveSpecFromAComponent' event (evid: 9612)
 *
 * Event description: When user remove spec that connected to component when merging/terminating
 *
 * @param {devCenterWhenUserRemoveSpecFromAComponentParams} params - The parameters for this event
 * @property {string} removing_reason - terminate/merge
 * @property {string} app_status - current status : DECLINED / PUBLISHED / IN_REVIEW / SUBMITTED / APPROVED / DRAFT
 * @property {GUID} app_id - app id
 * @property {string} component_id - (only for Edit) a unique identifier
 * @property {string} component_type - page / widget / dashboard etc.
 * @return {LogObject<devCenterWhenUserRemoveSpecFromAComponentParams>} LogObject<devCenterWhenUserRemoveSpecFromAComponentParams>
 */
export function devCenterWhenUserRemoveSpecFromAComponent(params) {
    return { evid: 9612, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterJsonEditorClickOnQuickFormatButton' event (evid: 9615)
 *
 * Event description: In the JSON Editor  - when a user is clicking on the quick format button
 *
 * @param {devCenterJsonEditorClickOnQuickFormatButtonParams} params - The parameters for this event
 * @property {string} component_category - Dashboard / Website /Integration / TBD
 * @property {boolean} is_wix_app - true = internal app, false = TPA's app
 * @property {string} app_status - current status : DECLINED / PUBLISHED / IN_REVIEW / SUBMITTED / APPROVED / DRAFT
 * @property {string} cta - quick format/ documentation
 * @property {GUID} app_id - app id
 * @property {string} component_id - (only for Edit) a unique identifier
 * @property {string} component_type - page / widget / dashboard etc.
 * @return {LogObject<devCenterJsonEditorClickOnQuickFormatButtonParams>} LogObject<devCenterJsonEditorClickOnQuickFormatButtonParams>
 */
export function devCenterJsonEditorClickOnQuickFormatButton(params) {
    return { evid: 9615, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterJsonEditorDocumentationSidepanelIsShown' event (evid: 9616)
 *
 * Event description: In the JSON Editor  - when the documentation side panel is shown/closed (notice the status field). The side panel is shown when a user is entering JSON editor or after a user clicked on documentation button.
 *
 * @param {devCenterJsonEditorDocumentationSidepanelIsShownParams} params - The parameters for this event
 * @property {string} sidepanel_status - shown/closed
 * @property {string} closing_trigger - when the sidepanel is closed reporting the closing trigger: X / documentation button. otherwise null (when the sidebar is shown the value isnull)
 * @property {string} component_category - Dashboard / Website /Integration / TBD
 * @property {boolean} is_wix_app - true = internal app, false = TPA's app
 * @property {string} app_status - current status : DECLINED / PUBLISHED / IN_REVIEW / SUBMITTED / APPROVED / DRAFT
 * @property {GUID} app_id - app id
 * @property {string} component_id - (only for Edit) a unique identifier
 * @property {string} component_type - page / widget / dashboard etc.
 * @property {boolean} is_example_tab - true if the component type sidepanel contains example tab, otherwise false.
 * @return {LogObject<devCenterJsonEditorDocumentationSidepanelIsShownParams>} LogObject<devCenterJsonEditorDocumentationSidepanelIsShownParams>
 */
export function devCenterJsonEditorDocumentationSidepanelIsShown(params) {
    return { evid: 9616, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterClickOnDocumentationExternalLink' event (evid: 9617)
 *
 * Event description: When a user is clicking on a link to external documentation in the DevCenter
 *
 * @param {devCenterClickOnDocumentationExternalLinkParams} params - The parameters for this event
 * @property {boolean} is_wix_app - true = internal app, false = TPA's app
 * @property {string} origin - the origin where the link appears, f.e: json ide documentation side panel
 * @property {string} app_status - current status : DECLINED / PUBLISHED / IN_REVIEW / SUBMITTED / APPROVED / DRAFT
 * @property {string} cta - the cta of the link
 * @property {GUID} app_id - app id
 * @property {string} component_type - when the documentation is for component type send the component type, otherwise null.
 * @return {LogObject<devCenterClickOnDocumentationExternalLinkParams>} LogObject<devCenterClickOnDocumentationExternalLinkParams>
 */
export function devCenterClickOnDocumentationExternalLink(params) {
    return { evid: 9617, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterBuildYourAppSelectUnselectExtensionTypeLabel' event (evid: 9618)
 *
 * Event description: In the Build Your App  - Add extensions modal - when a user is selecting/Unselecting an extension type label.
 *
 * @param {devCenterBuildYourAppSelectUnselectExtensionTypeLabelParams} params - The parameters for this event
 * @property {string} label_name - all extensions/ backend/ wix editor/ live site/ dashboard
 * @property {boolean} is_wix_app - true = internal app, false = TPA's app
 * @property {boolean} status - true when selecting a label, False when unselecting  a label
 * @property {string} app_status - current status : DECLINED / PUBLISHED / IN_REVIEW / SUBMITTED / APPROVED / DRAFT
 * @property {GUID} app_id - app id
 * @return {LogObject<devCenterBuildYourAppSelectUnselectExtensionTypeLabelParams>} LogObject<devCenterBuildYourAppSelectUnselectExtensionTypeLabelParams>
 */
export function devCenterBuildYourAppSelectUnselectExtensionTypeLabel(params) {
    return { evid: 9618, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterBuildYourAppSearchQueryInAddExtensionModal' event (evid: 9619)
 *
 * Event description: In the Build Your App  - Add extensions modal - when a user is typing in the search. the event will be sent in the end of the results (also when there are no results).
 *
 * @param {devCenterBuildYourAppSearchQueryInAddExtensionModalParams} params - The parameters for this event
 * @property {string} above_results - a list of all the above the fold component types that returned
 * @property {string} query - the user query search (the term he searched for)
 * @property {boolean} is_wix_app - true = internal app, false = TPA's app
 * @property {string} labels - the selected labels while the user typed in search
 * @property {string} app_status - current status : DECLINED / PUBLISHED / IN_REVIEW / SUBMITTED / APPROVED / DRAFT
 * @property {GUID} app_id - app id
 * @property {number} num_results - the number of extension types that returned
 * @property {string} below_results - a list of all the below the fold component types that returned
 * @return {LogObject<devCenterBuildYourAppSearchQueryInAddExtensionModalParams>} LogObject<devCenterBuildYourAppSearchQueryInAddExtensionModalParams>
 */
export function devCenterBuildYourAppSearchQueryInAddExtensionModal(params) {
    return { evid: 9619, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterClickOnCreateSubmitProposalInAddExtensionModal' event (evid: 9620)
 *
 * Event description: In the Build Your App  - Add extensions modal - when a user is clicking on create/submit proposal in add extension modal
 *
 * @param {devCenterClickOnCreateSubmitProposalInAddExtensionModalParams} params - The parameters for this event
 * @property {boolean} is_wix_app - true = internal app, false = TPA's app
 * @property {string} labels - the selected labels while the user click on learn more. If there are no labels null
 * @property {string} search_query - when the clicked extension is a search result send the search query. otherwise null
 * @property {string} app_status - current status : DECLINED / PUBLISHED / IN_REVIEW / SUBMITTED / APPROVED / DRAFT
 * @property {string} cta - create / submit proposal
 * @property {GUID} app_id - app id
 * @property {string} component_type - page / widget / dashboard etc.
 * @return {LogObject<devCenterClickOnCreateSubmitProposalInAddExtensionModalParams>} LogObject<devCenterClickOnCreateSubmitProposalInAddExtensionModalParams>
 */
export function devCenterClickOnCreateSubmitProposalInAddExtensionModal(params) {
    return { evid: 9620, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterOauthClickOnContactUs' event (evid: 97)
 *
 * Event description: Click On Contact Us
 *
 * @param {devCenterOauthClickOnContactUsParams} params - The parameters for this event
 * @property {string} app_id - app id
 * @return {LogObject<devCenterOauthClickOnContactUsParams>} LogObject<devCenterOauthClickOnContactUsParams>
 */
export function devCenterOauthClickOnContactUs(params) {
    return { evid: 97, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterOathFilterByCategory' event (evid: 98)
 *
 * Event description: Click On filter by category
 *
 * @param {devCenterOathFilterByCategoryParams} params - The parameters for this event
 * @property {string} category - which category selected
 * @property {string} app_id - app id
 * @property {string} hosting_platform - hosting platform (dev center, blocks etc.)
 * @property {string} platform - platform
 * @return {LogObject<devCenterOathFilterByCategoryParams>} LogObject<devCenterOathFilterByCategoryParams>
 */
export function devCenterOathFilterByCategory(params) {
    return { evid: 98, src: 96, endpoint: 'developer-center', params: params };
}
/**
 * A function to create a log object for the 'devCenterOathPermissionScopes' event (evid: 99)
 *
 * Event description: Click On Permission Scopes
 *
 * @param {devCenterOathPermissionScopesParams} params - The parameters for this event
 * @property {string} scope - Permission Scopes name
 * @property {string} category - which category selected, if it is from manually search - send search
 * @property {string} app_id - app id
 * @property {string} hosting_platform - hosting platform (dev center, blocks etc.)
 * @property {string} platform - platform
 * @return {LogObject<devCenterOathPermissionScopesParams>} LogObject<devCenterOathPermissionScopesParams>
 */
export function devCenterOathPermissionScopes(params) {
    return { evid: 99, src: 96, endpoint: 'developer-center', params: params };
}
//# sourceMappingURL=index.js.map